'use strict';

angular.module('PinMeTo.directives').directive('pmtPopover', [
	'$window',
	function ($window) {
		return {
			restrict: 'A',
			scope: {
				popoverTitle: '@',
				popoverBody: '@',
				popoverObtrusive: '@',
				popoverIgnoreSidebar: '@',
				popoverOpen: '=?'
			},
			link: function (scope, element) {
				element.addClass('popover');

				let pin;
				let overlay;
				let title;
				let body;
				let background;

				function layout() {
					element.removeClass('popover--down');
					overlay.css('left', '-120px');
					let headerRect = document.querySelector('header.header')?.getBoundingClientRect() || {
						height: 0
					};

					let sidebarWidth = 0;
					const sidebar = document.querySelector('.sidebar');
					const sidebarContent = document.querySelector('.sidebar__content') || {};
					if (sidebar && !scope.popoverIgnoreSidebar && sidebarContent.offsetWidth !== 0) {
						sidebarWidth = document.querySelector('.sidebar').getBoundingClientRect().width;
					}

					let elementRect = element[0].getBoundingClientRect();
					let overlayRect = overlay[0].getBoundingClientRect();
					let pinRect = pin[0].getBoundingClientRect();
					let leftEdgeDistanceToSidebar =
						pinRect.left + pinRect.width / 2 - sidebarWidth - overlayRect.width / 2;
					let rightEdgeDistanceToScreen =
						pinRect.left + pinRect.width / 2 + overlayRect.width / 2 - $window.innerWidth;

					if (rightEdgeDistanceToScreen > 0) {
						overlay.css('left', -120 - rightEdgeDistanceToScreen + 'px');
					}

					if (leftEdgeDistanceToSidebar < 0) {
						overlay.css('left', -120 - leftEdgeDistanceToSidebar + 'px');
					}

					if (elementRect.top < overlayRect.height + pinRect.height + headerRect.height) {
						element.addClass('popover--down');
					}
				}

				function enable() {
					element.addClass('popover--active');
					scope.popoverOpen = true;
					layout();
				}

				function disable() {
					// if (scope.popoverOpen === true) {
					element.removeClass('popover--active');
					scope.popoverOpen = false;
					// }
				}

				if (scope.popoverObtrusive) {
					background = angular.element('<div class="popover__background"></div>');
					element.append(background);
					background[0].addEventListener('click', disable, false);
				}

				if (scope.popoverTitle || scope.popoverBody) {
					pin = angular.element('<div class="popover__pin"></div>');
					overlay = angular.element('<div class="popover__overlay"></div>');
					pin.append(overlay);

					element.append(pin);

					if (scope.popoverTitle) {
						title = angular.element('<div class="popover__title"></div>');
						title.text(scope.popoverTitle);
						overlay.append(title);

						scope.$watch('popoverTitle', function (newValue) {
							title.text(newValue);
						});
					}

					if (scope.popoverBody) {
						body = angular.element('<div class="popover__body"></div>');
						body.text(scope.popoverBody);
						overlay.append(body);

						scope.$watch('popoverBody', function (newValue) {
							body.text(newValue);
						});
					}
				} else {
					pin = angular.element(element[0].querySelector('.popover__pin'));
					overlay = angular.element(element[0].querySelector('.popover__overlay'));
				}

				document.addEventListener('touchmove', disable, false);
				document.addEventListener('scroll', disable, false);

				if (scope.popoverOpen == null) {
					element[0].addEventListener('click', enable, false);
					element[0].addEventListener('mouseenter', enable, false);
					element[0].addEventListener('mouseleave', disable, false);
				} else {
					scope.$watch('popoverOpen', function (newVal /*, oldVal*/) {
						if (newVal === true) {
							enable();
						} else {
							disable();
						}
					});
				}
			}
		};
	}
]);
